/* tslint:disable */
/* eslint-disable */
/**
 * AI Secretary
 * AI-powered voice assistant platform for automated appointment scheduling, customer communication, and CRM integration
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PageUserResponseDTO } from '../models';
// @ts-ignore
import type { UserDeactivateResponseDTO } from '../models';
// @ts-ignore
import type { UserRoleUpdateDTO } from '../models';
// @ts-ignore
import type { UserRoleUpdateResponseDTO } from '../models';
/**
 * AdminUsersApi - axios parameter creator
 * @export
 */
export const AdminUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUserApiV1AdminUsersUserIdDeactivatePost: async (userId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deactivateUserApiV1AdminUsersUserIdDeactivatePost', 'userId', userId)
            const localVarPath = `/api/v1/admin/users/{user_id}/deactivate`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUserApiV1AdminUsersUserIdDeactivatePost_1: async (userId: string, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deactivateUserApiV1AdminUsersUserIdDeactivatePost_1', 'userId', userId)
            const localVarPath = `/api/v1/admin/users/{user_id}/deactivate`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet: async (organizationId: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/users/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2: async (organizationId: string, limit?: number, offset?: number, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2', 'organizationId', organizationId)
            const localVarPath = `/api/v1/admin/users/organization/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesApiV1AdminUsersUserIdRolesPatch: async (userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRolesApiV1AdminUsersUserIdRolesPatch', 'userId', userId)
            // verify required parameter 'userRoleUpdateDTO' is not null or undefined
            assertParamExists('updateUserRolesApiV1AdminUsersUserIdRolesPatch', 'userRoleUpdateDTO', userRoleUpdateDTO)
            const localVarPath = `/api/v1/admin/users/{user_id}/roles`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRoleUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesApiV1AdminUsersUserIdRolesPatch_3: async (userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserRolesApiV1AdminUsersUserIdRolesPatch_3', 'userId', userId)
            // verify required parameter 'userRoleUpdateDTO' is not null or undefined
            assertParamExists('updateUserRolesApiV1AdminUsersUserIdRolesPatch_3', 'userRoleUpdateDTO', userRoleUpdateDTO)
            const localVarPath = `/api/v1/admin/users/{user_id}/roles`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (authorization != null) {
                localVarHeaderParameter['authorization'] = String(authorization);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRoleUpdateDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminUsersApi - functional programming interface
 * @export
 */
export const AdminUsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminUsersApiAxiosParamCreator(configuration)
    return {
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeactivateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.deactivateUserApiV1AdminUsersUserIdDeactivatePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId: string, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDeactivateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.deactivateUserApiV1AdminUsersUserIdDeactivatePost_1']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageUserResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId, limit, offset, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoleUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId, userRoleUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.updateUserRolesApiV1AdminUsersUserIdRolesPatch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRoleUpdateResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId, userRoleUpdateDTO, authorization, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminUsersApi.updateUserRolesApiV1AdminUsersUserIdRolesPatch_3']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminUsersApi - factory interface
 * @export
 */
export const AdminUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminUsersApiFp(configuration)
    return {
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDeactivateResponseDTO> {
            return localVarFp.deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Deactivate a user in Auth0 by blocking the account.
         * @summary Deactivate User
         * @param {string} userId 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId: string, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserDeactivateResponseDTO> {
            return localVarFp.deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageUserResponseDTO> {
            return localVarFp.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * List users for an explicit organization ID.
         * @summary List Users For Organization
         * @param {string} organizationId 
         * @param {number} [limit] 
         * @param {number} [offset] 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<PageUserResponseDTO> {
            return localVarFp.listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId, limit, offset, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRoleUpdateResponseDTO> {
            return localVarFp.updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId, userRoleUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a user\'s Auth0 role assignments.
         * @summary Update User Roles
         * @param {string} userId 
         * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
         * @param {string} [authorization] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserRoleUpdateResponseDTO> {
            return localVarFp.updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId, userRoleUpdateDTO, authorization, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminUsersApi - object-oriented interface
 * @export
 * @class AdminUsersApi
 * @extends {BaseAPI}
 */
export class AdminUsersApi extends BaseAPI {
    /**
     * Deactivate a user in Auth0 by blocking the account.
     * @summary Deactivate User
     * @param {string} userId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).deactivateUserApiV1AdminUsersUserIdDeactivatePost(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deactivate a user in Auth0 by blocking the account.
     * @summary Deactivate User
     * @param {string} userId 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId: string, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).deactivateUserApiV1AdminUsersUserIdDeactivatePost_1(userId, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List users for an explicit organization ID.
     * @summary List Users For Organization
     * @param {string} organizationId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet(organizationId, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * List users for an explicit organization ID.
     * @summary List Users For Organization
     * @param {string} organizationId 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId: string, limit?: number, offset?: number, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).listUsersForOrganizationApiV1AdminUsersOrganizationOrganizationIdGet_2(organizationId, limit, offset, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a user\'s Auth0 role assignments.
     * @summary Update User Roles
     * @param {string} userId 
     * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).updateUserRolesApiV1AdminUsersUserIdRolesPatch(userId, userRoleUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a user\'s Auth0 role assignments.
     * @summary Update User Roles
     * @param {string} userId 
     * @param {UserRoleUpdateDTO} userRoleUpdateDTO 
     * @param {string} [authorization] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminUsersApi
     */
    public updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId: string, userRoleUpdateDTO: UserRoleUpdateDTO, authorization?: string, options?: RawAxiosRequestConfig) {
        return AdminUsersApiFp(this.configuration).updateUserRolesApiV1AdminUsersUserIdRolesPatch_3(userId, userRoleUpdateDTO, authorization, options).then((request) => request(this.axios, this.basePath));
    }
}

